import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { ITakeoverSectionPayload } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

const deleteTakeoverSection = async (payload: ITakeoverSectionPayload) => {
  const takeoverSection = payload.screen.sections.find(
    (section) => section.config?.events?.LAYOUT_TIMER !== undefined,
  );
  let sectionID = takeoverSection?.screenSectionId;

  await requestCCApi({
    url: `/screenSections/${sectionID}`,
    method: 'DELETE',
  });
};

export const useDeleteTakeoverSection = () => {
  return useMutation({
    mutationFn: deleteTakeoverSection,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.screenSections.invalidateAll());
    },
  });
};
